module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedSite) ? _c('div', {
    staticClass: "data-map-banner"
  }, [_c('div', {
    staticClass: "data-map-banner__header"
  }, [_vm._v("\n    " + _vm._s(_vm.selectedSite.stationName) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--strong"
  }, [_vm._v("\n      Collected by:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedSite.collectionPartner) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--strong"
  }, [_vm._v("\n      Watershed Unit (HUC):\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedSite.hucName) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--strong"
  }, [_vm._v("\n      First collected:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text"
  }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.selectedSite.firstCollectionDate)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row data-map-banner__row--top-space"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--nww data-map-banner__text--strong"
  }, [_vm._v("\n      Last E. coli Result:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--nww"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedSite.lastEColiResult) + " (MPN/100mL) on " + _vm._s(_vm._f("formatDate")(_vm.selectedSite.lastCollectionDate)) + "\n    ")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da11c16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/DataMapBanner.vue
// module id = 446
// module chunks = 1